import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["navigationDirection"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { wrapDisplayName } from '@cian/react-utils';
import { QuestionSwitchAnim } from './QuestionSwitchAnim';
import { EFormNavigationDirections } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export var withQuestionSwitchAnim = function withQuestionSwitchAnim(Component) {
  var Wrapper = function Wrapper(props) {
    var navigationDirection = props.navigationDirection,
        rest = _objectWithoutProperties(props, _excluded);

    return /*#__PURE__*/_jsx(QuestionSwitchAnim, {
      currentScreenId: props.question.code,
      isBackwards: navigationDirection === EFormNavigationDirections.Backward,
      children: /*#__PURE__*/_jsx(Component, _objectSpread({}, rest))
    });
  };

  Wrapper.displayName = wrapDisplayName(Wrapper, 'withQuestionSwitchAnim');
  return Wrapper;
};